import React, { useState, useRef, useEffect } from 'react';
import { useI18n } from '../i18n';

const API_URL = process.env.REACT_APP_API_URL || '';

/* Inline SVG flags — no external dependencies, reliable on all OS */
const FLAGS = {
  es: (
    <svg viewBox="0 0 30 20" width="24" height="16" style={{ borderRadius: 3, display: 'block' }}>
      <rect width="30" height="20" fill="#c60b1e"/>
      <rect y="5" width="30" height="10" fill="#ffc400"/>
    </svg>
  ),
  en: (
    <svg viewBox="0 0 60 30" width="24" height="16" style={{ borderRadius: 3, display: 'block' }}>
      <rect width="60" height="30" fill="#00247d"/>
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#cf142b" strokeWidth="4"/>
      <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10"/>
      <path d="M30,0 V30 M0,15 H60" stroke="#cf142b" strokeWidth="6"/>
    </svg>
  ),
  fr: (
    <svg viewBox="0 0 30 20" width="24" height="16" style={{ borderRadius: 3, display: 'block' }}>
      <rect width="10" height="20" fill="#002395"/>
      <rect x="10" width="10" height="20" fill="#fff"/>
      <rect x="20" width="10" height="20" fill="#ed2939"/>
    </svg>
  ),
  pt: (
    <svg viewBox="0 0 30 20" width="24" height="16" style={{ borderRadius: 3, display: 'block' }}>
      <rect width="30" height="20" fill="#dc2626"/>
      <rect width="12" height="20" fill="#006600"/>
      <circle cx="12" cy="10" r="4" fill="#ffcc00"/>
      <circle cx="12" cy="10" r="3" fill="#dc2626"/>
      <rect x="10.5" y="7.5" width="3" height="5" rx="0.5" fill="#fff"/>
    </svg>
  ),
  ca: (
    <svg viewBox="0 0 30 20" width="24" height="16" style={{ borderRadius: 3, display: 'block' }}>
      <rect width="30" height="20" fill="#fcdd09"/>
      <rect y="2.2" width="30" height="2.2" fill="#da121a"/>
      <rect y="6.6" width="30" height="2.2" fill="#da121a"/>
      <rect y="11" width="30" height="2.2" fill="#da121a"/>
      <rect y="15.4" width="30" height="2.2" fill="#da121a"/>
    </svg>
  ),
};

export default function LanguageSwitcher({ currentUser }) {
  const { locale, changeLocale, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = async (code) => {
    changeLocale(code);
    setOpen(false);
    if (currentUser?.id) {
      try {
        await fetch(`${API_URL}/api/users/${currentUser.id}/preferences`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ language: code }),
        });
      } catch {}
    }
  };

  const currentLang = languages.find(l => l.code === locale) || languages[0];

  return (
    <div className="language-dropdown" ref={ref}>
      <button
        className="language-dropdown-btn"
        onClick={() => setOpen(v => !v)}
        aria-label={currentLang.label}
        title={currentLang.label}
      >
        {FLAGS[locale]}
        <span className="language-dropdown-arrow">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <div className="language-dropdown-menu">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-dropdown-item${locale === lang.code ? ' active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              {FLAGS[lang.code]}
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
